/**
 * StudentQuizReview — la relecture du quiz de prérequis (`<QuizReview>`), à la place de l'énoncé,
 * comme le quiz qu'elle suit : à la fin du quiz (« Continuer » ouvre l'activité, comme l'ancienne
 * correction sous le résultat), puis par « Revoir le quiz ».
 *
 * La relecture est au moteur (`useQuizReview`, arrivé par la porte du quiz).
 *
 * La même page que le quiz et que l'énoncé : « Continuer » dans le pied fixe, en bas, la bulle tandem
 * du live au-dessus de lui ; la relecture lui garde elle-même sa place, en fin de défilement.
 */
import React from "react"

import { QuizReview } from "../../../../../../design-system/student"
import { PageTemplate } from "../../../../../../design-system/templates/PageTemplate"
import { type QuizReviewHandle } from "../../../../../../engine/activity/prerequisite/useQuizReview"
import { quizReviewViewModel } from "../../../../view-models/student/Activity/quizReviewViewModel"

export function StudentQuizReview({ review }: { review: QuizReviewHandle }) {
    const vm = quizReviewViewModel(review.state)
    if (!vm.open) return null

    return (
        <PageTemplate scroll={false} padding="0" reserveFloating={false} contentContainerStyle={FLUSH}>
            <QuizReview
                review={vm.review}
                loading={vm.loading}
                error={vm.error}
                onRetry={review.retry}
                onClose={review.close}
                endAction={vm.continueLabel != null ? { label: vm.continueLabel, onPress: review.close } : undefined}
                bottomInset={false}
            />
        </PageTemplate>
    )
}

/** Le pied de la relecture touche le bas : le gabarit ne pose pas sa marge haute et basse. */
const FLUSH = { paddingVertical: 0 }
